module.exports = __webpack_public_path__ + "static/media/no_photo_favourite.7da84c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_photo/no_photo_favourite.png
// module id = 1502
// module chunks = 0